/**
 * Cust product summary — ported from ecoflow-tech/assets/theme.js
 * - custom cust-solar-panels / inputChange
 * - customBuyButtonsPrice variant update (else if branch in _updatePrice)
 *
 * Loaded by cust-product-template so Shopify overwrites of theme.js
 * cannot remove summary recalculation again.
 */
(function () {
  if (window.__custProductSummaryFromTechBound) return;
  window.__custProductSummaryFromTechBound = true;

  function boot() {
    if (!document.querySelector('.section-cust-product-template')) return;
    if (!window.theme || !theme.Currency || typeof theme.Currency.formatMoney !== 'function') {
      setTimeout(boot, 50);
      return;
    }

    var event = new Event('change', { bubbles: true });

    // --- tech: custom cust-solar-panels ---
    var custSolarPanelsHeading = document.querySelector('.section-cust-product-template .cust-solar-panels__heading');
    var customBuyButtonsPrice =
      document.querySelector('.section-product-template .price-wrapper') ||
      document.querySelector('.section-cust-product-template .price-wrapper');
    var customVaiantItems = document.querySelectorAll('.section-product-template .custom-variant-item');
    var customVaiantOthers = document.querySelectorAll('.section-cust-product-template .variant-selected-others');
    var customStickyPrice = document.querySelector('.sticky-price-wrapper .product-sticky-price');

    var priceFormat = theme.priceCurrencyCodeEnable ? theme.moneyFormatWithCurrency : theme.moneyFormat;
    var comparePriceFormat = theme.comparePriceCurrencyCodeEnable ? theme.moneyFormatWithCurrency : theme.moneyFormat;

    var quantity_input = document.querySelector('.quantity_block .product-form__input--quantity');

    function inputChangeHandler(item) {
      if (!customBuyButtonsPrice) return;

      var selected_html = '';
      var product_quantity = quantity_input ? parseInt(quantity_input.value, 10) || 1 : 1;
      var price = (parseInt(customBuyButtonsPrice.dataset.price, 10) || 0) * product_quantity;
      var compare_price = (parseInt(customBuyButtonsPrice.dataset.comparePrice, 10) || 0) * product_quantity;

      if (item && item.classList.contains('cust-solar-panels__item')) {
        if (custSolarPanelsHeading && custSolarPanelsHeading.dataset.title) {
          var panelItems = document.querySelectorAll('.section-cust-product-template .cust-solar-panels__item');
          var powerTotal = 0;
          panelItems.forEach(function (panelItem) {
            if (panelItem.querySelector('input') && panelItem.querySelector('input').checked) {
              powerTotal += parseInt(panelItem.dataset.power, 10) || 0;
            }
          });
          custSolarPanelsHeading.innerHTML = custSolarPanelsHeading.dataset.title.replace(
            '{total_power}',
            powerTotal + ' W'
          );
        }
      }

      document.querySelectorAll('.section-product-template .custom-variant-item input:checked').forEach(function (inputChecked) {
        var variantItem = inputChecked.closest('.custom-variant-item');
        if (!variantItem) return;
        var quantity = variantItem.querySelector('.product-form__input--quantity')
          ? parseInt(variantItem.querySelector('.product-form__input--quantity').value, 10) || 1
          : 1;
        if (
          variantItem.querySelector('.product-form__input--quantity') &&
          variantItem.querySelector('.product-form__input--quantity').name == 'expand-capacity-quantity'
        ) {
          var checkedExpand = variantItem.querySelector("input[name='expand-capacity-quantity']:checked");
          quantity = checkedExpand ? parseInt(checkedExpand.value, 10) || 1 : 1;
        }
        price = price + (parseInt(variantItem.dataset.price, 10) || 0) * quantity;
        compare_price = compare_price + (parseInt(variantItem.dataset.comparePrice, 10) || 0) * quantity;
        selected_html =
          selected_html +
          '<div class="variant-selected-others__item"><span class="title">' +
          (variantItem.dataset.title || '') +
          '</span><span class="num">x' +
          quantity +
          '</span></div>';
      });

      if (customVaiantOthers && customVaiantOthers.length > 0) {
        customVaiantOthers.forEach(function (el) {
          el.innerHTML = selected_html;
        });
      }

      var regularEl = customBuyButtonsPrice.querySelector('.regular-price');
      if (regularEl) {
        regularEl.innerHTML = theme.Currency.formatMoney(price, priceFormat);
      }
      if (customStickyPrice) {
        customStickyPrice.innerHTML = theme.Currency.formatMoney(price, priceFormat);
      }

      var wrapperComparePriceEl = customBuyButtonsPrice.querySelector('.compare-price');
      var wrapperTotalSavingsEl = customBuyButtonsPrice.querySelector('.total-savings');
      if (compare_price > 0 && compare_price > price) {
        if (wrapperComparePriceEl) {
          wrapperComparePriceEl.innerHTML = theme.Currency.formatMoney(compare_price, comparePriceFormat);
        }
        if (wrapperTotalSavingsEl) {
          wrapperTotalSavingsEl.innerHTML =
            '-' + theme.Currency.formatMoney(compare_price - price, comparePriceFormat);
        }
      } else {
        if (wrapperComparePriceEl) wrapperComparePriceEl.innerHTML = '';
        if (wrapperTotalSavingsEl) wrapperTotalSavingsEl.innerHTML = '';
      }

      document.querySelectorAll('[data-payment-trigger]').forEach(function (dom) {
        dom.setAttribute('data-payment-amount', price / 100.0);
      });
      document.querySelectorAll('.affirm-as-low-as').forEach(function (dom) {
        dom.setAttribute('data-amount', String(Math.round(price)));
      });
      if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
        window.affirm.ui.refresh();
      }

      var selectedInput = document.querySelector('.swatch-element input:checked');
      if (selectedInput) {
        var swatchEle = selectedInput.closest('.swatch-element');
        var params1 = swatchEle.getAttribute('data-params-1');
        var params2 = swatchEle.getAttribute('data-params-2');
        var params3 = swatchEle.getAttribute('data-params-3');
        document.querySelectorAll('.product-params-block .product-params__item').forEach(function (el, index) {
          var titleEl = el.querySelector('.title');
          if (!titleEl) return;
          if (index == 0 && params1) titleEl.innerHTML = params1;
          else if (index == 1 && params2) titleEl.innerHTML = params2;
          else if (index == 2 && params3) titleEl.innerHTML = params3;
        });
      }
    }

    function bindInputChange(input, item) {
      if (!input || input.__custSummaryTechBound) return;
      input.__custSummaryTechBound = true;
      input.addEventListener('change', function () {
        inputChangeHandler(item);
      });
    }

    if (quantity_input && !quantity_input.closest('.modal__dialog')) {
      bindInputChange(quantity_input, null);
    }
    customVaiantItems.forEach(function (item) {
      item.querySelectorAll('input').forEach(function (input) {
        bindInputChange(input, item);
      });
    });

    // qty +/- → dispatch change (tech custom_quantity_info_container path)
    document.querySelectorAll('.quantity_block .qty_btn, .custom-variant-item .qty_btn').forEach(function (btn) {
      if (btn.__custSummaryQtyBound) return;
      btn.__custSummaryQtyBound = true;
      btn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (btn.classList.contains('disabled')) return;
          var qtyWrap = btn.closest('.qty');
          var inputEl = qtyWrap && qtyWrap.querySelector('[name="quantity"], .product-form__input--quantity');
          if (!inputEl) return;
          var qty = parseInt(inputEl.value, 10) || 1;
          qty = btn.classList.contains('minus_btn') ? qty - 1 : qty + 1;
          if (qty < 1) qty = 1;
          inputEl.value = qty;
          var minus = qtyWrap.querySelector('.minus_btn');
          if (minus) {
            if (qty > 1) {
              minus.classList.remove('disabled');
              minus.removeAttribute('disabled');
            } else {
              minus.classList.add('disabled');
              minus.setAttribute('disabled', 'disabled');
            }
          }
          inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        },
        true
      );
    });

    // --- tech _updatePrice else if(customBuyButtonsPrice) ---
    function onVariant(variant) {
      if (!variant || !customBuyButtonsPrice) return;

      var variant_metafields_ele = document.querySelector('[data-variants-custommetafields-json]');
      var show_price = variant.price;
      if (variant_metafields_ele) {
        try {
          var jsonData = JSON.parse(variant_metafields_ele.innerHTML);
          if (jsonData[variant.id]) show_price = jsonData[variant.id];
        } catch (err) {}
      }

      customBuyButtonsPrice.dataset.price = show_price;
      customBuyButtonsPrice.dataset.comparePrice = variant.compare_at_price || 0;
      customBuyButtonsPrice.dataset.saving = (variant.compare_at_price || 0) - show_price;
      customBuyButtonsPrice.setAttribute('data-price', show_price);
      customBuyButtonsPrice.setAttribute('data-compare-price', variant.compare_at_price || 0);
      customBuyButtonsPrice.setAttribute('data-saving', (variant.compare_at_price || 0) - show_price);

      document.querySelectorAll('.cust-selected-products').forEach(function (custSelectedProducts) {
        var variantTitle = custSelectedProducts.querySelector('.variant-title');
        var regularPrice = custSelectedProducts.querySelector('.variant-price .regular-price');
        var comparePrice = custSelectedProducts.querySelector('.variant-price .compare-price');
        var variantSelectedOthers = custSelectedProducts.querySelector('.variant-selected-others');
        if (variantTitle) variantTitle.innerText = variant.title;
        if (regularPrice) {
          regularPrice.innerHTML = theme.Currency.formatMoney(show_price, priceFormat);
        }
        if (comparePrice) {
          if (variant.compare_at_price > show_price) {
            comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, comparePriceFormat);
          } else {
            comparePrice.innerHTML = '';
          }
        }
        if (variantSelectedOthers) variantSelectedOthers.innerHTML = '';
      });

      // tech: dispatch quantity change to recalc add-ons into summary
      var updateItem = document.querySelector('.quantity_block .product-form__input--quantity');
      if (updateItem) {
        updateItem.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        inputChangeHandler(null);
      }
    }

    function onVariantEvent(evt) {
      if (evt && evt.detail && evt.detail.variant) onVariant(evt.detail.variant);
    }

    document.addEventListener('variantPriceChange', onVariantEvent, true);
    document.addEventListener('variantChange', onVariantEvent, true);

    // fallback: product json + option/master change (when theme events are missing)
    function getProductVariants() {
      var variants = [];
      var productJsonEl = document.querySelector('[data-product-json]');
      if (productJsonEl) {
        try {
          var raw = JSON.parse(productJsonEl.textContent || productJsonEl.innerHTML);
          var product = raw && (raw.product || raw);
          if (product && product.variants) variants = product.variants;
        } catch (err) {}
      }
      if (!variants.length) {
        var productJsonIdEl =
          document.querySelector('[id^="ProductJson-"]') ||
          document.getElementById('product-variant-data');
        if (productJsonIdEl) {
          try {
            var data = JSON.parse(productJsonIdEl.textContent || productJsonIdEl.innerHTML);
            if (Array.isArray(data)) variants = data;
            else if (data && data.variants) variants = data.variants;
          } catch (err) {}
        }
      }
      return variants;
    }

    function resolveVariantFromDom() {
      var variants = getProductVariants();
      var master = document.querySelector('.product-form__variants, select[name="id"]');
      if (master && variants.length) {
        var id = String(master.value);
        var found = variants.find(function (v) {
          return String(v.id) === id;
        });
        if (found) return found;
      }
      if (master && master.selectedIndex >= 0) {
        var opt = master.options[master.selectedIndex];
        if (opt) {
          return {
            id: opt.value,
            title: opt.text,
            price: parseInt(opt.getAttribute('data-price'), 10) || 0,
            compare_at_price: parseInt(opt.getAttribute('data-compare-price'), 10) || 0
          };
        }
      }
      return null;
    }

    function onOptionDomChange() {
      // swatch-js may set master value without change; wait a tick
      setTimeout(function () {
        var variant = resolveVariantFromDom();
        if (variant) onVariant(variant);
      }, 0);
    }

    var master = document.querySelector('.product-form__variants, select[name="id"]');
    if (master) {
      master.addEventListener('change', onOptionDomChange);
    }
    document.querySelectorAll('.single-option-selector').forEach(function (sos) {
      if (sos.__custSummaryOptionBound) return;
      sos.__custSummaryOptionBound = true;
      sos.addEventListener('change', onOptionDomChange);
    });
    document.querySelectorAll('.swatch-element input').forEach(function (input) {
      if (input.__custSummaryOptionBound) return;
      input.__custSummaryOptionBound = true;
      input.addEventListener('change', onOptionDomChange);
    });

    if (custSolarPanelsHeading) {
      var inputs = document.querySelectorAll('.section-cust-product-template .cust-solar-panels__item input');
      if (inputs[0]) inputs[0].dispatchEvent(event);
      else inputChangeHandler(null);
    } else if (customVaiantItems[0]) {
      var first = customVaiantItems[0].querySelectorAll('input')[0];
      if (first) first.dispatchEvent(event);
      else inputChangeHandler(null);
    } else {
      inputChangeHandler(null);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
